import React from 'react';

import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import { green, yellow, red } from '@material-ui/core/colors';

const ColorSuccessButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText(green[700]),
      backgroundColor: green[700],
      '&:hover': {
        backgroundColor: green[900],
      },
    },
})) (Button);

export const ButtonPrimary = React.forwardRef((props, ref) => {
    const { name } = props;

    return (
        <Button
            ref={ref}
            variant="contained"
            size="small"
            color="primary"
            {...props}
        >
            {name}
        </Button>
    )
})

export const ButtonDefault = props => {
    const { name } = props;

    return (
        <Button
            variant="contained"
            size="small"
            color="default"
            {...props}
        >
            {name}
        </Button>
    )
}

export const ButtonSecondary = props => {
    const { name } = props;

    return (
        <Button
            variant="contained"
            size="small"
            color="secondary"
            {...props}
        >
            {name}
        </Button>
    )
}

export const ButtonSuccess = props => {
    const { name } = props;

    return (
        <ColorSuccessButton 
            variant="contained"
            size="small"
            {...props}
        >
            {name}
        </ColorSuccessButton>
    )
}

const ColorWarningButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText(yellow[700]),
      backgroundColor: yellow[700],
      '&:hover': {
        backgroundColor: yellow[900],
      },
    },
})) (Button);

export const ButtonWarning = props => {
    const { name } = props;

    return (
        <ColorWarningButton
            variant="contained"
            size="small"
            {...props}
        >
            {name}
        </ColorWarningButton>
    )
}

const ColorDangerButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText(red[700]),
      backgroundColor: red[700],
      '&:hover': {
        backgroundColor: red[900],
      },
    },
})) (Button);

export const ButtonDanger = props => {
    const { name } = props;

    return (
        <ColorDangerButton
            variant="contained"
            size="small"
            {...props}
        >
            {name}
        </ColorDangerButton>
    )
}

export default ButtonPrimary;